export { deepFreeze } from './deepfreeze';
export { deepMerge } from './deepmerge';
export { diff, DiffResult } from './diff';
export { patch } from './patch';
